import { useCallback, useEffect, useMemo } from 'react';
import { MouseActions } from '../models';

export function useOutsideClick(elements: Element[], callback: () => void) {
  const elementsInner = useMemo(() => Array.from(elements), [elements]);

  const handleClick = useCallback(
    (e: MouseEvent) => {
      const modal = document.querySelector('.ant-modal-root');
      if (modal) {
        elementsInner.push(modal);
      }
      if (elementsInner.every((element) => !element.contains(e.target as Node))) {
        callback();
      }
    },
    [callback, elementsInner],
  );

  useEffect(() => {
    document.addEventListener(MouseActions.Click, handleClick, true);

    return () => document.removeEventListener(MouseActions.Click, handleClick, true);
  });
}
